import axios from "axios";
import React, { useEffect, useMemo } from "react";
import { FaEdit, FaPlus, FaTrashAlt } from "react-icons/fa";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { Button } from "../../components/Button";
import { Loader } from "../../components/Loader";
import { Table } from "../../components/Table";

export const Categories: React.FC = () => {
  const { data, isLoading, refetch } = useQuery("Get Categories", async () => {
    const response = await axios.get("/categories");
    return response.data.categories.map((el: any, index: number) => ({
      id: index + 1,
      nameAr: el.names?.find((n: any) => n.language === "ar")?.name,
      nameEn: el.names?.find((n: any) => n.language === "en")?.name,
      nameUr: (
        <span className="text-xs font-urdu">
          {el.names?.find((n: any) => n.language === "ur")?.name}
        </span>
      ),
      logo: (
        <img
          src={process.env.REACT_APP_UPLOAD_BASE_URL + el.logo}
          className="max-w-8"
          alt="logo"
        />
      ),
      createdAt: el.createdAt,
      updatedAt: el.updatedAt,
      actions: (
        <div className="flex gap-4">
          <Link to={`/dashboard/categories/edit/${el.id}`}>
            <Button lightYellow className="h-8">
              <FaEdit />
            </Button>
          </Link>
          <Button lightRed className="h-8" onClick={() => handleDelete(el.id)}>
            <FaTrashAlt />
          </Button>
        </div>
      ),
    }));
  });
  const columns = useMemo(
    () => [
      {
        Header: "#",
        accessor: "id",
      },
      {
        Header: "Name (Ar)",
        accessor: "nameAr",
      },
      {
        Header: "Name (En)",
        accessor: "nameEn",
      },
      {
        Header: "Name (Ur)",
        accessor: "nameUr",
      },
      {
        Header: "Logo",
        accessor: "logo",
      },
      {
        Header: "Created At",
        accessor: "createdAt",
        Cell: ({ row }: { row: { original: { createdAt: string } } }) => {
          const { createdAt } = row.original;
          return createdAt ? (
            new Date(createdAt).toLocaleDateString()
          ) : (
            <p className="w-full px--4">-</p>
          );
        },
      },
      {
        Header: "",
        accessor: "actions",
      },
    ],
    []
  );

  const handleDelete = async (id: string) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You can't reverse this deletion!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete!",
      cancelButtonText: "Cancel",
    }).then(async (result: any) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`/categories/${id}`);
          refetch();
          Swal.fire({
            title: "Deleted",
            text: "The Category has been removed",
            icon: "success",
            confirmButtonText: "Ok",
          });
        } catch (err: any) {
          Swal.fire({
            title: "Error",
            text:
              err?.response?.data.message || "The Category doesn't removed.",
            icon: "error",
            confirmButtonText: "Ok",
          });
        }
      }
    });
  };

  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading)
    return (
      <div className="flex justify-center items-center pt-32">
        <Loader />
      </div>
    );

  return (
    <div>
      <header className="my-3 flex justify-between items-center">
        <h3 className="text-2xl font-medium">All Categories</h3>
        <Link to="add">
          <Button className="!bg-primary flex items-center gap-2">
            <FaPlus />
            Add New
          </Button>
        </Link>
      </header>
      {!data && !isLoading && <div>Categories doesn't exist</div>}
      {data && <Table columns={columns} data={data} filter={true} />}
    </div>
  );
};
